/**
 * Ссылка на заказ у продавца (KAN-611): где брать код входа.
 * Чистые функции без React.
 */

export const SELLER_NAME_MAX = 80;
export const SELLER_URL_MAX = 300;

/** Возвращает URL, только если он парсится и протокол http: или https:. */
export function safeHttpUrl(url: string | null | undefined): string | null {
  const raw = (url ?? '').trim();
  if (!raw) return null;
  try {
    const parsed = new URL(raw);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return null;
    }
    return raw;
  } catch {
    return null;
  }
}

/** Текст ошибки или null: пустая ссылка допустима. */
export function validateSellerUrl(url: string): string | null {
  if (!url.trim()) return null;
  if (!safeHttpUrl(url)) {
    return 'Ссылка должна начинаться с http:// или https://';
  }
  return null;
}

/** Номер заказа из конца пути /order/<n>, иначе null. */
export function orderNumberFromUrl(url: string): string | null {
  try {
    const match = new URL(url).pathname.match(/\/order\/(\d+)\/?$/);
    return match ? match[1] : null;
  } catch {
    return null;
  }
}

/** KAN-670: подпись рейтинга продавца для title и aria-label. */
export const SELLER_RATING_MAX = 5;

export function ratingTitle(value: number | null | undefined): string {
  return value
    ? `рейтинг продавца ${value} из ${SELLER_RATING_MAX}`
    : 'рейтинг продавца не задан';
}

/** KAN-674: подпись кнопки-звезды (title и aria-label). */
export function ratingSetTitle(n: number): string {
  return `Поставить рейтинг ${n} из ${SELLER_RATING_MAX}`;
}
